import React from 'react';
import clsx from 'clsx';
import { ReactComponent as ChevronDown } from '../../../icons/chevron-down.svg';
import { useState } from 'react';
import { useRef } from 'react';
import { useEffect } from 'react';

const VehiclesSort = ({ data, onChange, className, style, disable, placeholder }) => {
  const dropdownRef = useRef(null);
  const [isShowDropdown, setIsShowDropdown] = useState(false);

  useEffect(() => {
    // Add a click event listener to the document to handle clicks outside the dropdown.
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsShowDropdown(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      // Remove the event listener when the component unmounts.
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsShowDropdown(!isShowDropdown);
  };

  return (
    <div className={clsx('vehicles-sort', className)} style={style} ref={dropdownRef}>
      <div className={clsx('vehicles-sort__field', disable ? 'disable' : '')} onClick={toggleDropdown}>
        <div className="vehicles-sort__field__input">{placeholder}</div>
        <ChevronDown className={`vehicles-sort__field__chevron ${isShowDropdown ? 'down' : ''}`} />
      </div>
      {/* drop down */}
      {isShowDropdown && (
        <ul className="vehicles-sort__field__dropdown">
          {data ? (
            data.map((item) => (
              <li key={item.id}>
                <input
                  type="radio"
                  id={item.id}
                  name="sort"
                  value={item.id}
                  checked={item.checked}
                  readOnly
                  onClick={onChange}
                />
                <label htmlFor={item.id}>{item.name}</label>
              </li>
            ))
          ) : (
            <li>Data Not Found</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default VehiclesSort;
